import createAxios from "./axiosHttp";

function saveLogo(body) {
  const axios = createAxios();
  const urlPath = "portal-config";
  return axios.post(urlPath, body);
}

function getLogo() {
  const axios = createAxios();
  const urlPath = "portal-config";
  return axios.get(urlPath);
}

export const portalConfigService = {
  saveLogo,
  getLogo,
};
